import { EBillingCadence, IAutoCheckout } from '../../../interfaces';

export type TPolicyCheckout = {
  policyCheckout: IAutoCheckout | null;
  billingCadence?: EBillingCadence;
};

export function getCheckoutProps({
  policyCheckout,
  billingCadence = 'monthly',
}: TPolicyCheckout) {
  const monthlyBill = policyCheckout?.billing_amounts.find(
    (bill) => bill.billing_cadence === 'monthly'
  );

  const semiAnnualBill = policyCheckout?.billing_amounts.find(
    (bill) => bill.billing_cadence === 'semi_annual'
  );

  const nextBill =
    policyCheckout?.billing_amounts.find(
      (bill) => bill.billing_cadence === billingCadence
    ) || semiAnnualBill;

  return {
    updatedMonthlyBill: monthlyBill,
    updatedSemiAnnualBill: semiAnnualBill,
    updatedPrice: parseFloat(nextBill?.total || '0'),
    paymentDue: parseFloat(policyCheckout?.amount_due || '0'),
  };
}
